import { ReactNode } from "react";
import styles from "./grid-container.module.scss";

type Props = {
  children: ReactNode;
};

const GridContainer = ({ children }: Props) => (
  <div className={styles.grid_container}>{children}</div>
);

export default GridContainer;
